module.exports = __webpack_public_path__ + "static/media/DO.502f6c90.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/DO.svg
// module id = 241
// module chunks = 0